import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const pesquisarCompatibilidadesService = async (data: {
  empreendId: number;
  dataInicio: string;
  dataFim: string;
  nome: string;
  celular: string;
  tipoInteresse: string;
}) => {
  const Token = validateToken();

  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/compatibilidades/pesquisar`;

    try {
      const response = await axios.post(URL, data, {
        headers: { Authorization: Token.AuthStr },
      });

      if (response && response.data) {
        return response.data;
      }

      return false;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return false;
};
